import API from '../dataApi';

// -- User Profile (address) ----------------------------------------------------
export const getUserProfile = () => API.get('/user-profile');
export const updateUserProfile = (data) => API.put('/user-profile', data);
